import { cartRepository } from '~/api/repository/cart';

export const CART_QUERY_KEY = {
  all: ['cart'] as const,

  // 장바구니 상품 개수 조회
  count: () => ({
    queryKey: ['/api/market-place/v1/shopping-cart-items/count'] as const,
    queryFn: () => cartRepository.getCartCount(),
  }),
};
